var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngineerWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_352_1516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9182 64.0525L0.118164 50.8225C4.22816 46.8225 8.61816 42.4125 13.1882 38.1825C17.1882 34.4825 18.5482 29.8825 18.1882 24.6725C17.9643 21.4301 18.4332 18.1772 19.5637 15.1301C20.6941 12.0829 22.4603 9.31133 24.7447 6.9995C27.0291 4.68767 29.7794 2.88857 32.8129 1.72182C35.8463 0.55506 39.0934 0.047369 42.3382 0.232493C43.9382 0.332493 45.5282 0.732493 47.8782 1.13249C44.9582 4.06249 42.4082 6.69249 39.7682 9.18249C37.1282 11.6725 34.2882 14.2625 31.6782 16.6725C32.9482 21.2825 34.0382 25.2125 35.0982 29.0725L47.0282 32.3025L62.3882 16.4125C64.4982 20.6725 64.0682 24.4925 63.3282 28.2125C61.3882 38.0925 52.1182 45.7525 41.9782 45.9725C40.7282 45.9725 39.4782 45.9725 38.2282 45.9725C35.9164 45.8848 33.6125 46.2917 31.4706 47.166C29.3287 48.0404 27.3982 49.362 25.8082 51.0425C21.5782 55.4125 17.2382 59.6925 12.9182 64.0525Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_1516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.81,
    height: 63.87,
    fill: "white",
    transform: "translate(0.118164 0.182495)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineerWhite);
export default __webpack_public_path__ + "static/media/engineer-white.84ed3bcb8d32b27cb9cb9cc12c311e41.svg";
export { ForwardRef as ReactComponent };